import {CircularProgress} from '@logistics-frontend/blocks/legacy'
import {Button} from '@logistics-frontend/blocks/lpc/button'
import {AdaptiveDialog, DialogActions, DialogContent, DialogTitleWithClose} from '@logistics-frontend/blocks/lpc/dialog'
import {useI18n} from '@logistics-frontend/core/i18n'
import {CancelRules, CancelState} from '@yandex-taxi/js-integration-api'
import {AsyncStatus, useCancelRequest} from '@yandex-taxi/react-integration-api'
import React, {useState} from 'react'

import {DisplayableOrder} from '../../utils'
import {useButtonClasses, useDialogActionsClasses, useGreyClasses} from './classes'

type Props = {
  order: DisplayableOrder
}

type State = {
  title: string
  message: string
}

const CancelButton: React.FC<Props> = ({order}) => {
  const t = useI18n()
  const [state, setState] = useState<State | undefined>()
  const dialogActionsClasses = useDialogActionsClasses()
  const buttonClasses = useButtonClasses()
  const greyClasses = useGreyClasses()
  const [cancelHandler, {status}] = useCancelRequest(order.id)
  const defaultCancelRules: CancelRules = {
    message_support: '',
    state: CancelState.FREE,
    title: t('order.list.cancel_dialog_default_title', 'Бесплатная отмена'),
    message: t('order.list.cancel_dialog_default_message', 'Вы действительно хотите отменить заказ?'),
  }
  const cancelRules = order.cancelRules || defaultCancelRules

  const openHandler = () =>
    setState({
      title: cancelRules.title,
      message: cancelRules.message,
    })
  const closeHandler = () => setState(undefined)
  const confirmHandler = () => {
    closeHandler()
    cancelHandler()
  }

  const loading = status === AsyncStatus.PENDING
  const disabled: boolean = order.cancelDisabled || loading

  return (
    <>
      <Button
        color="primary"
        disabled={disabled}
        onClick={disabled ? undefined : openHandler}
        size="small"
        startIcon={loading ? <CircularProgress color="secondary" size={14} /> : undefined}
        variant="contained"
      >
        {t('order.list.cancel_button_text', 'Отменить')}
      </Button>
      {state && (
        <AdaptiveDialog maxWidth="md" onClose={closeHandler} fullWidth open>
          <DialogTitleWithClose onClose={closeHandler} littleCloseIcon>
            {state.title}
          </DialogTitleWithClose>
          <DialogContent>
            <div className={greyClasses.root}>{state.message}</div>
          </DialogContent>
          <DialogActions classes={dialogActionsClasses}>
            <Button classes={buttonClasses} color="primary" onClick={confirmHandler} variant="contained">
              {t('order.list.cancel_dialog_confirm_button_text', 'Отменить заказ')}
            </Button>
            <Button classes={buttonClasses} color="secondary" onClick={closeHandler} variant="contained">
              {t('order.list.cancel_dialog_reject_button_text', 'Не отменять')}
            </Button>
          </DialogActions>
        </AdaptiveDialog>
      )}
    </>
  )
}

export default CancelButton
